var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNlpMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 160,
    viewBox: "0 0 101 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.091 50.909H55.2732C50.8549 50.909 47.2732 54.4907 47.2732 58.909V116.444C47.2732 120.863 50.8549 124.444 55.2732 124.444H122.43C122.888 124.444 123.332 124.602 123.688 124.89L149.091 145.454V58.909C149.091 54.4907 145.51 50.909 141.091 50.909Z",
    stroke: "#26FF7B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3633 76.3636H120",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3633 98.1818H120",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.366 48.82V26.1817C116.366 21.7634 112.784 18.1817 108.366 18.1817H18.911C14.4927 18.1817 10.911 21.7635 10.911 26.1817V98.1817L32.8752 83.21C33.2073 82.9836 33.5999 82.8626 34.0017 82.8626H47.2746",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeMiterlimit: 6.00562
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlpMobile);
export default __webpack_public_path__ + "static/media/nlp-mobile.b2846cb6.svg";
export { ForwardRef as ReactComponent };